import { Text } from '@sparemin/blockhead';
import React from 'react';
import BemCSSTransition from 'components/BemCssTransition';
import { formatDurationMillis } from 'utils/time';
import { useClipSelectVideoPlayerAnimation } from './ClipSelectVideoPlayerAnimationContext';
import { basePlayerBlock as block } from './utils';

export type ClipSelectPlayerDurationProps = {
  currentTime: number;
  duration: number;
};

const ClipSelectPlayerDuration: React.FC<ClipSelectPlayerDurationProps> = ({
  currentTime,
  duration,
}) => {
  const animations = useClipSelectVideoPlayerAnimation();
  const formatTime = (timeInSeconds: number) => {
    return formatDurationMillis(timeInSeconds * 1000, {
      minute: 'numeric',
      second: '2-digit',
      trim: false,
    });
  };

  return (
    <div className={block('duration-tag')}>
      <BemCSSTransition
        className={block('duration-tag-content')}
        {...animations.durationTagContent}
      >
        <div>
          <Text variant="mono" className={block('playback-time')}>
            {formatTime(currentTime)}
          </Text>
          <Text variant="mono" className={block('duration-separator')}>
            /
          </Text>
          <Text variant="mono" className={block('duration-time')}>
            {formatTime(duration)}
          </Text>
        </div>
      </BemCSSTransition>
    </div>
  );
};

export default ClipSelectPlayerDuration;
